import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { AgentscriptService_updated } from '../services/agent-script-service/agent-script-service';
import { data } from 'jquery';

@Component({
  selector: 'app-notificationmodal',
  templateUrl: './notificationmodal.component.html',
  styleUrls: ['./notificationmodal.component.scss']
})
export class NotificationmodalComponent {
  datatableload: boolean;

  datatablepagination() {
// alert()
    $("#notificationlisttable_wrapper").remove();

    setTimeout(() => {
      ($('#notificationlisttable') as any).dataTable({
        "language": {
          "paginate": {
            "previous": "",
            "next": ""
          },
          "lengthMenu": "Records per page _MENU_",
        },
        pageLength: 10,
        // "order": [[2, "asc"]],

        "columnDefs": [
          { "orderable": false, "targets": 0 },
          { "orderable": false, "targets": 4 },
          // { 'orderable': false, 'targets': 5 }
        ],

        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
          fixedColumns: {
            start: 1,
            end: 1
        },
        paging: true,        
        fixedHeader: true,
        // scrollX: false,
        scrollY: 450,
        destroy:true,
        dom: 'rtlip',

        drawCallback: function (settings) {
          const api = this.api();
          const rows = api.rows({ page: 'current' }).nodes();
          let startIndex = api.page() * api.page.len() + 1;

          $(rows).each(function (index) {
            $('td', this).eq(0).html(startIndex.toString()); // Convert to string before setting as HTML content
            startIndex++;
          });
        },
      });
    }, 200);

    this.datatableload=true
    
  }

  updatemode(notifyid:any)
  {

    console.log(notifyid)
  
    // console.log(index)
    this.agentscriptservice.updatereadmode(notifyid).subscribe((data: any) => {
    // this.http.put(this.backendUrl+'updateMode?notifyid='+notifyid.id,{}).subscribe((data:any)=>
    // {
      console.log(data)
      if(data)
      notifyid.readmode=true
    this.datatableload=false;
      this.agentscriptservice.getuserallnotifications().subscribe((data:any)=>{
        this.datatablepagination()
      })
    })
   
  }
  closeModal() {
    this.dialogRef.close(data);
  }
  openreport(data:any)
  {
   
    console.log(data)
    // console.log(index)
    this.http.put(this.backendUrl+'updateMode?notifyid='+data.id,{}).subscribe((data:any)=>
    {
      console.log(data)
      if(data)
      this.agentscriptservice.getuserallnotifications()
    })
    // this.getrefreshuserlist();
    

    console.log(data)
    this.dialogRef.close(data);
  }

  markasread(data:any)
  {

  }

  constructor(private agentscriptservice:AgentscriptService_updated,private http:HttpClient,public dialogRef: MatDialogRef<NotificationmodalComponent>){}


  backendUrl = environment.apiURL;
  ngOnInit()
  {
    console.log('in notification modal popup')
    this.getuserallnotifications();
  }

  // updatemode(notifyid:any)
  // {

  //   console.log(notifyid)
  
  //   // console.log(index)
  //   this.agentscriptservice.updatereadmode(notifyid).subscribe((data: any) => {
  //   // this.http.put(this.backendUrl+'updateMode?notifyid='+notifyid.id,{}).subscribe((data:any)=>
  //   // {
  //     console.log(data)
  //     if(data)
  //     notifyid.readmode=true
  //     this.agentscriptservice.getuserallnotifications()
  //   })
  //   // this.getrefreshuserlist();
    
  // }


  userallnotifications:any=[];
  filteredNotifications:any
  getuserallnotifications()
  {
    this.http.get(this.backendUrl+'getUserAllNotifications').subscribe((data:any)=>
    {
      this.datatableload=false
      console.log(data)
      this.userallnotifications=data;
      this.filteredNotifications=data;

      this.datatablepagination()
    })
  }

}
